<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cuY0Xn/tc-custom/9780813140186.jpg?1700249831868" alt="This image is the cover for the book One of Morgan's Men"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One of Morgan's Men
      </h1>
      <p class="bookDescription body article font2">
        <b>This annotated Civil War memoir provides a detailed account of General Morgan’s famous battles and raids from a Confederate soldier’s perspective.</b><br/><br/>John Marion Porter grew up working at his family's farm and dry goods store in Butler County, Kentucky. He was studying to become a lawyer when the Civil War began. As the son of a family of slave owners, Porter identified with the Southern cause and quickly enlisted in the Confederate army. He and his lifelong friend Thomas Henry Hines served in the Ninth Kentucky Calvary under John Hunt Morgan, the “Thunderbolt of the Confederacy.”<br/><br/>When the war ended, Porter began writing detailed memoirs of his experiences during the war years, including tales of scouting behind enemy lines, sabotaging a Union train, being captured and held as a prisoner of war, and searching for an army to join after his release.<br/><br/>Editor Kent Masterson Brown spent several years preparing Porter's memoir for publication, clarifying details and adding annotations to provide historical context. <i>One of Morgan's Men </i>is a fascinating firsthand account of the life of a Confederate soldier.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John M. Porter, Kent Masterson Brown
      </h2>
      
      <p class="authorDescription body article">Kent Masterson Brown is the creator of the magazine The Civil War. He is the author or editor of several books, including Cushing of Gettysburg: The Story of a Union Artillery Commander, Retreat from Gettysburg: Lee, Logistics, and the Pennsylvania Campaign, and The Civil War in Kentucky: Battle for the Bluegrass State. He lives in Lexington, Kentucky.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fd95020